export const menu = () => {
  if (document.querySelector(".header__hamburger")) {
    const hamburger = document.querySelector(".header__hamburger");
    const nav = document.querySelector(".header__nav");
    const header = document.querySelector(".header");
    for (let i = 0; i < 3; i++) {
      const span = document.createElement("span");
      hamburger.appendChild(span);
    }
    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("__js_isActive");
      nav.classList.toggle("__js_isActive");
      header.classList.toggle("header--collapsed");
    });
    nav.querySelector("ul").addEventListener("click", () => {
      nav.classList.remove("__js_isActive");
      hamburger.classList.remove("__js_isActive");
      header.classList.remove("header--collapsed");
    });
    document.querySelector(".header").addEventListener("mouseleave", () => {
      nav.classList.remove("__js_isActive");
      hamburger.classList.remove("__js_isActive");
      header.classList.remove("header--collapsed");
    });
  }

  let m = { x: 0, y: 0 };
  let p = { x: 0, y: 0 };
  let t = { x: 0, y: 0 };
  let s = 0;
  let a = 0;
  const sp = 0.075;
  let tracking = false;
  let e;

  function trackMouse(ev) {
    m = { x: ev.clientX, y: ev.clientY };
  }
  function anim() {
    if (!tracking) return;

    [t.x, t.y] = [t.x + (m.x - t.x) * sp, t.y + (m.y - t.y) * sp];

    const [dx, dy] = [m.x - p.x, m.y - p.y];
    [p.x, p.y] = [m.x, m.y];

    const v = Math.min(Math.sqrt(dx ** 2 + dy ** 2) * 4, 150);
    const ts = (v / 150) * 0.5;

    s += (ts - s) * sp;
    a = v > 20 ? Math.atan2(dy, dx) * (180 / Math.PI) : a;

    e.style.transform = `translate(${t.x}px, ${t.y}px) rotate(${a}deg) scale(${
      1 + s
    }, ${1 - s})`;

    requestAnimationFrame(anim);
  }
  function createTracker(event, li) {
    if (e) return;

    if (window.innerWidth > 1020) {
      m = { x: event.clientX, y: event.clientY };
      p = { x: event.clientX, y: event.clientY };
      t = { x: event.clientX, y: event.clientY };

      e = document.createElement("div");
      e.className = "nav--hover";
      li.appendChild(e);

      window.addEventListener("mousemove", trackMouse);
      tracking = true;
      requestAnimationFrame(anim);
    }
  }
  function removeTracker() {
    if (!e) return;

    if (window.innerWidth > 1020) {
      e.remove();
      e = null;

      window.removeEventListener("mousemove", trackMouse);
      tracking = false;
    }
  }
  document.querySelectorAll(".header__nav li").forEach((item) => {
    item.addEventListener("mouseenter", (e) => createTracker(e, item));
    item.addEventListener("mouseleave", (e) => removeTracker(e, item));
  });
};
